export default __webpack_public_path__ + "static/media/makita.1ba67014.jpg";